import { render } from "./moeTop.vue?vue&type=template&id=5fbc640b&scoped=true"
import script from "./moeTop.vue?vue&type=script&lang=js"
export * from "./moeTop.vue?vue&type=script&lang=js"

import "./moeTop.vue?vue&type=style&index=0&id=5fbc640b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbc640b"]])

export default __exports__